<template>
  <el-dialog
    center
    @open="initData"
    :title="$t('История изменений')"
    :visible.sync="modals[nameModal]">
    <table-history :tableData="loadData"
                   :fieldInfoList = "fieldInfoList"
                   :load="load"
                   :updateData="updateData"
                   :searchStart="searchStart"
                   :sortData="sortData"
                   :setSort="demo"
                   :backData="backData"
                   :configName = "configName"
    >
    </table-history>
    <span slot="footer" class="dialog-footer">
              <button class="btn btn-danger" @click="toggleModal(nameModal)">Закрыть</button>
            </span>
  </el-dialog>
</template>
<script>
  import { HISTORY_COMPANY, RETURN_COMPANY } from "./store/type";
  import {historyModal} from "../../../mixins/history/HistoryModal";

  export default {
    name: 'HistoryCompany',
    mixins: [historyModal],
    data : function () {
      return {
        history : HISTORY_COMPANY,
        return : RETURN_COMPANY,
        paramsReturn : {
          CompanyId: this.$route.params.CompanyId
        },
        paramsGet : {
          CompanyId : this.$route.params.CompanyId,
          self: this
        }
      }
    },
  }
</script>
